import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[digitsOnlyInput]',
  host: {
    '(input)': 'onInput($event.target)',
  },
})
export class DigitsOnlyInputDirective {
  private readonly ngControl = inject(NgControl);
  private readonly digitsRegex = /[^0-9]/g;

  public onInput(element: EventTarget): void {
    const inputEl = element as HTMLInputElement;
    if (!inputEl.value) {
      return;
    }

    let value = inputEl.value;

    if (this.digitsRegex.test(value)) {
      value = value.replace(this.digitsRegex, '');
    }

    if (value !== inputEl.value) {
      this.ngControl.control.setValue(value);
    }
  }
}
